export const TAB_INDEX = {
  SUMMARY: 0,
  SCORECARD: 1,
  RISK: 2,
  TRANSCRIPT: 3,
  RAW: 4
} as const;

export const TAB_ARTIFACT_MAP: Record<number, string> = {
  [TAB_INDEX.SUMMARY]: "summary",
  [TAB_INDEX.SCORECARD]: "scorecard",
  [TAB_INDEX.RISK]: "risk",
  [TAB_INDEX.TRANSCRIPT]: "transcript",
  [TAB_INDEX.RAW]: "raw"
};

export const ARTIFACT_TAB_MAP: Record<string, number> = Object.fromEntries(
  Object.entries(TAB_ARTIFACT_MAP).map(([index, artifact]) => [artifact, Number(index)])
);

export const getTabIndexFromArtifact = (artifact: string | null): number => {
  if (!artifact) {
    return TAB_INDEX.SUMMARY;
  }
  return ARTIFACT_TAB_MAP[artifact.toLowerCase()] ?? TAB_INDEX.SUMMARY;
};

export const getArtifactFromTabIndex = (tabIndex: number): string | null => {
  return TAB_ARTIFACT_MAP[tabIndex] ?? null;
};
